import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import clientwalletApiController from "../../services/clientwallet.service";
import HandleError from "../HandleError";
import HandleResponse from "../HandleResponse";

export const ClientWalletViewApi = createAsyncThunk("clientwallet/view", async (formValues, thunkAPI) => {
  try {
    const resposedata = await clientwalletApiController
      .view(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "view"))
      .catch((error) => HandleError(thunkAPI, error, "view"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

const initialState = {
  isWalletData: null,
  isApiStatus: {
    ClientWalletViewApi: "",
  },
};

const clientwalletSlice = createSlice({
  name: "clientwallet",
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(ClientWalletViewApi.pending, (state) => {
        state.isApiStatus = { ...state.isApiStatus, ClientWalletViewApi: "loading" };
      })
      .addCase(ClientWalletViewApi.fulfilled, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, ClientWalletViewApi: "succeeded" };
        state.isWalletData = action.payload?.data || action.payload || null;
      })
      .addCase(ClientWalletViewApi.rejected, (state) => {
        state.isApiStatus = { ...state.isApiStatus, ClientWalletViewApi: "failed" };
        state.isWalletData = null;
      });
  },
});

export const { reset } = clientwalletSlice.actions;
export default clientwalletSlice.reducer;
